import React, { useCallback } from 'react';
import { RelatedEventCard } from '@/components/RelatedEvents/RelatedEventCard';
import { OrganizerEvent } from '../types';
import { RelatedEvent } from '@/components/RelatedEvents/types';
import { AffiliateCodes, LISTING_HEAP_IDS } from '@/components/_shared/constants';
import { track } from '@eventbrite/legacy-infra.datalayer-library';

export interface MoreOrganizerEventCardProps {
  organizerEvent: OrganizerEvent;
  affiliateCode?: AffiliateCodes;
}

// Convert OrganizerEvent to RelatedEvent format
const convertToRelatedEvent = (organizerEvent: OrganizerEvent): RelatedEvent => {
  return {
    id: organizerEvent.id,
    name: organizerEvent.name,
    url: organizerEvent.url,
    imageUrl: organizerEvent.imageUrl,
    startDate: organizerEvent.startDate,
    startTime: organizerEvent.startTime,
    timezone: organizerEvent.timezone,
    isFree: organizerEvent.isFree,
    isOnlineEvent: organizerEvent.isOnlineEvent,
    isPromoted: organizerEvent.isPromoted,
    formattedPriceString: organizerEvent.formattedPriceString,
    venue: organizerEvent.venue,
    urgencySignals: organizerEvent.urgencySignals,
    specialDiscounts: organizerEvent.specialDiscounts,
    promotedListingMetadata: organizerEvent.promotedListingMetadata,
    savedByYou: organizerEvent.savedByYou,
    hasOpenDiscount: organizerEvent.hasOpenDiscount,
  };
};

export const MoreOrganizerEventCard: React.FC<MoreOrganizerEventCardProps> = ({ organizerEvent, affiliateCode }) => {
  const relatedEvent = convertToRelatedEvent(organizerEvent);

  const handleCardClick = useCallback(() => {
    track({
      eventName: LISTING_HEAP_IDS.ORGANIZER_MORE_EVENTS_CLICK,
      eventData: {
        event_id: relatedEvent.id,
        event_name: relatedEvent.name,
      },
    });
  }, [relatedEvent.id, relatedEvent.name]);

  return (
    <div onClick={handleCardClick}>
      <RelatedEventCard relatedEvent={relatedEvent} affiliateCode={affiliateCode} />
    </div>
  );
};
